import MyGoogleMap from 'javascripts/modules/google-map';

class LocationMap {

	constructor(){
		this._init();
	}

	_init(){
		const args = {
			// streetViewControl: false,
			// panControl:        false,
			// scrollwheel:       false,
			cluster: true
		};
	  const map = new MyGoogleMap('location-map', args);
            
            var elementChamp = jQuery('#centrer_carte_zone');
            
            elementChamp.on('change',function(){
                if(elementChamp.find('option:selected').attr('data-latitude') !== '0' && elementChamp.find('option:selected').attr('data-longitude') !== '0'){
                    map._moveMapZone(elementChamp.find('option:selected').attr('data-latitude'),elementChamp.find('option:selected').attr('data-longitude'));
                }
            });
            setTimeout(function(){
                if(elementChamp.find('option:selected').attr('data-latitude') !== '0' && elementChamp.find('option:selected').attr('data-longitude') !== '0'){
                    map._moveMapZone(elementChamp.find('option:selected').attr('data-latitude'),elementChamp.find('option:selected').attr('data-longitude'));
                }
            },1000);
	}

}

export const locationMap = new LocationMap();